/**
 * @(#)2019/9/6.
 * tag组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Tag, { defaultProps } from "./tag";
import { ITextBasePropTypes } from "../IpropType/basePropTypes";
import PropTypes from "prop-types";
Tag.propTypes = {
  ...ITextBasePropTypes,
  group: PropTypes.array,
};

Tag.defaultProps = defaultProps();

/*
 * YxTag
 当children为数组的时候，所有的参数都支持函数， 如果数组项是字符串，则直接显示字符串， 如果数组项是对象，则使用函数来定义参数值，当前项会被当做函数形参
 注意，如果数组项为对象， 必须包含children字段，或在参数中指定取值函数  children(data)=>{return data.xxx}
 styleParam:(data)=>{
   return data.type
 }
 * @param children {ReactNode} 子节点
*/

export default Tag;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Tag/index.js